var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailAgent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_175_385)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_175_385)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_175_385)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_175_385)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_175_385",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.4152 0.585449H0.585938V47.4147H47.4152V0.585449Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_175_385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.2175 0.585449H5.78359C2.91301 0.585449 0.585938 2.91252 0.585938 5.7831V42.217C0.585938 45.0877 2.91301 47.4147 5.78359 47.4147H42.2175C45.0881 47.4147 47.4152 45.0877 47.4152 42.217V5.7831C47.4152 2.91252 45.0881 0.585449 42.2175 0.585449Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1753 12.9048C26.8759 12.4112 25.4759 12.1392 24.0052 12.1392C19.8249 12.1392 16.1584 14.3048 14.043 17.5786H21.5776C24.6297 17.5786 27.2083 15.6344 28.1753 12.9148V12.9048Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0455 28.3059C35.5693 26.9661 35.8615 25.5258 35.8615 24.0048C35.8615 19.8446 33.7159 16.1982 30.4824 14.0728V21.7484C30.4824 24.7602 32.3863 27.3188 35.0455 28.3059Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3026 30.4212C23.2706 30.4212 20.6919 32.3553 19.7148 35.0448C21.0444 35.5585 22.4849 35.8506 23.9858 35.8506C28.166 35.8506 31.8326 33.6848 33.9479 30.4111H26.2925L26.3026 30.4212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9546 19.7036C12.4408 21.0333 12.1387 22.4838 12.1387 23.9947C12.1387 28.2052 14.3345 31.8819 17.6384 33.9972V26.3115C17.6384 23.2594 15.6844 20.6706 12.9546 19.7036Z",
    fill: "white"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_175_385"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_175_385"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_175_385"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_175_385"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 46.8293,
    fill: "white",
    transform: "translate(0 0.585449)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailAgent);
export default __webpack_public_path__ + "static/media/email-agent.1f1964b0390a25a9bc95b37c186792bd.svg";
export { ForwardRef as ReactComponent };